import { render, staticRenderFns } from "./tabFundProjectApply.vue?vue&type=template&id=5947bcda&"
import script from "./tabFundProjectApply.vue?vue&type=script&lang=ts&"
export * from "./tabFundProjectApply.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports